import React from "react";
import { withStyles } from "@material-ui/core/styles";
import TextField from "@material-ui/core/TextField";
import Button from "@material-ui/core/Button";
import Avatar from "@material-ui/core/Avatar";

const styles = theme => ({
  textField: {
    marginLeft: theme.spacing.unit,
    marginRight: theme.spacing.unit,
    width: 200
  },
  button: { margin: "1em" },
  pic: {
    width: 200
  }
});

const TwoStepAuthenticationForm = props => (
  <>
    <Avatar
      src={props.qr_url}
      size={200}
      style={{ width: 200, height: 200, borderRadius: 0 }}
    />

    <form autoComplete="off">
      <TextField
        id="token"
        label="Token"
        className={props.classes.textField}
        margin="normal"
        onChange={e => props.onChange(e.target.value)}
      />
      <Button
        variant="contained"
        className={props.classes.button}
        color="primary"
        onClick={props.validate}
      >
        Validate
      </Button>
    </form>
  </>
);

export default withStyles(styles)(TwoStepAuthenticationForm);
